module.exports = __webpack_public_path__ + "9b0db948ca812072aaa13183aadcf163.svg";